var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangePasswordZona(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 480,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#change-password-zona_svg__clip0_4141_8903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.69 0H10C4.477 0 0 4.477 0 10v232.06c0 5.523 4.477 10 10 10h307.69c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10z",
    fill: "#FFF0EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.69 30.95H0v-21a10 10 0 0110-10h307.69a10 10 0 0110 10v21z",
    fill: "#FFB092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6 20.14a4.67 4.67 0 100-9.34 4.67 4.67 0 000 9.34z",
    fill: "#FF662A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.79 20.14a4.67 4.67 0 100-9.34 4.67 4.67 0 000 9.34z",
    fill: "#B93401"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.99 20.14a4.67 4.67 0 100-9.34 4.67 4.67 0 000 9.34z",
    fill: "#FFE5DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.47 127.64h-13V84.2a4.39 4.39 0 00-4.34-4.34h-40.54a4.4 4.4 0 00-4.35 4.34v43.44h-13V84.2a17.381 17.381 0 0117.37-17.36h40.51a17.378 17.378 0 0117.37 17.36l-.02 43.44z",
    fill: "#FF662A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.62 106.78H111.07a10.88 10.88 0 00-10.85 10.85v83.06a10.89 10.89 0 0010.85 10.86h105.55a10.89 10.89 0 0010.85-10.86v-83.06a10.88 10.88 0 00-10.85-10.85z",
    fill: "#FFB092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.6 183.61l-5.55-29.33a11.745 11.745 0 005.091-13.172 11.752 11.752 0 00-11.24-8.55 11.752 11.752 0 00-11.072 15.863 11.749 11.749 0 004.681 5.789l-5.42 29.37 23.51.03z",
    fill: "#FFF0EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.37 442.85s-11.61 6.74-16.19 8.81c-4.58 2.07-13 5.05-15.69 6.68-2.69 1.63.49 6.47 3.27 8.61 2.78 2.14 10.54-.41 13.13-1.27 2.59-.86 14.09-4.78 17.2-4.49 3.11.29 5.66 1.48 7.07-.11 1.41-1.59 4-12.33 4-12.33l1.4-4.88-10.51-4.91-3.68 3.89zM360.9 443.83s11 7.67 15.43 10.11c4.43 2.44 12.56 6.08 15.08 7.92 2.52 1.84-1 6.42-4 8.33-3 1.91-10.48-1.27-13-2.34-2.52-1.07-13.65-5.91-16.77-5.87-3.12.04-5.77 1-7-.69-1.23-1.69-3-12.61-3-12.61l-1-5 10.88-4 3.38 4.15z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3 296.88s.38 4.76 1 12.58c2.69 34.49 9.84 128.4 8.32 134.48 0 0 6.51 4.65 15.82 0 0 0 2.79-75.39 3.72-82.84.63-5 5-31.45 7.8-48.55 1.41-8.54 2.44-14.74 2.44-14.74l-39.1-.93z",
    fill: "#3A3B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.95 312.55c1.41-8.54 2.44-14.74 2.44-14.74l-39.09-.93s.38 4.76 1 12.58l35.65 3.09z",
    fill: "#131556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.31 296.88s-.29 3.66-.77 9.82c-2.5 31.92-10.1 131-8.54 137.24 0 0-6.51 4.65-15.82 0 0 0-2.79-75.39-3.72-82.84-.64-5.13-5.27-33.28-8.08-50.26-1.26-7.65-2.16-13-2.16-13l39.09-.96z",
    fill: "#3A3B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.37 310.84c-1.26-7.65-2.16-13-2.16-13l39.09-.93s-.29 3.66-.77 9.82l-36.16 4.11z",
    fill: "#131556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.06 116.91l1.39-4.91 2.45-8.71h23.04l2.45 8.7 1.39 4.92-7.33 16.41h-14.66l-8.73-16.41z",
    fill: "#FFC9B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.37 111.99l-2.45-8.7h-23l-2.45 8.7s10.3 6.91 15.65 6.31c5.35-.6 12.25-6.31 12.25-6.31z",
    fill: "#EFB39C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.43 77.81s.7-12.56 6.63-20.59 22.69-6.28 27.58-4.54c4.89 1.74 9.42 7.33 10.82 16.06 1.4 8.73.69 13.26.69 13.26l-9.78 14.66-29-2.44-6.94-16.41z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.48 86.19s.7 10.47 2.44 12.56 12.22 13.79 15 15c1.6.7 9.42 1.05 11.17-.35s11.17-13.61 12.21-15.36c1.04-1.75 2.45-12.56 2.45-12.56s5.23-1.4 5.58-3.14c.35-1.74 1.75-9.08-.35-8.38-2.1.7-5.93 4.89-5.93 4.89s-.35-15.71-4.54-16.41c-4.19-.7-7 1.4-13.61 1.75-6.61.35-11.17-2.79-15.71-2.09-4.54.7-6.28 12.91-6.63 16a28.214 28.214 0 01-4.19-2.03c-2.79-1.92-4.53-2.1-4.88.69-.35 2.79.35 6.29 3.14 7a6.32 6.32 0 013.85 2.43z",
    fill: "#FFC9B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.59 82.17s-1.56 14.08-1 14.49c.56.41 3.49.92 4.42 0 .93-.92-.82-14.49-.82-14.49h-2.6z",
    fill: "#EFB39C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.82 82l1.39.17c.379 1.71.846 3.399 1.4 5.06a3.618 3.618 0 001.76 1.75c5.41 1.4 9.77.63 11.52-.17 2.27-1 3.14-7.33 3.14-7.33l3.49-5.07-.35-1.57s-2.09 2.8-3 2.62c-3.652-.426-7.324-.66-11-.7-4 0-5.58 1.4-5.58 1.4l-4.36.17s-.7-1.22-3.49-1.39c-2.79-.17-10.13-.35-13.62.35l-4.53-2.27-.53 1.05 4.71 5.41s.88 6.28 3.15 7.33c1.75.8 6.1 1.57 11.51.17a3.658 3.658 0 001.75-1.75 49.75 49.75 0 001.39-5.06l1.4-.17",
    fill: "#131556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.18 145.87l11.4-16.28 6.98 2.32 5.12-.93 11.87 17.92-20.48 40.02-14.89-43.05z",
    fill: "#C8C9EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.49 162.16l6.28-16.75h4.65l6.05 16.75-9.3 19.08-7.68-19.08z",
    fill: "#8182BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.88 114.69l-5.59 5.59 8.85 26.29 12.79-18.38-16.05-13.5zM339.2 114.69l10.47 5.59-8.84 26.29-12.8-18.38 11.17-13.5z",
    fill: "#E1E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.84 147.96s-4.42-10.7-4-12.33c.42-1.63 6.05-7.44 6.05-7.44a1.548 1.548 0 012.1 0c1.16.93 5.58 5.58 5.58 7s-.93 9.54-3.26 13c.06.01-5.08 1.64-6.47-.23z",
    fill: "#AEAFE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.44 128.42l-4.19 39.76-7.44 70.53 9.31 62.83 53.86 2.75v-4.15l47.12-.46 9.31-68.88-9.44-62.9-5.92-39.48-20.25-10.11-21.07 56.65-22.44-56.65-28.85 10.11z",
    fill: "#3A3B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.73 196.28c.53 5.59.76 11.18.88 16.76.09 2.8.07 5.59.1 8.38l-.07 8.37-.24 8.37c-.14 2.79-.22 5.58-.41 8.36-.34 5.58-.78 11.15-1.52 16.72-.54-5.59-.77-11.18-.89-16.76-.09-2.79-.07-5.58-.1-8.38l.08-8.37.24-8.37c.14-2.79.22-5.58.42-8.36.33-5.57.77-11.14 1.51-16.72z",
    fill: "#131556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.15 272.57l-5.24 5.58s2.45 4.54 1 6.28c-1.45 1.74-10.47 8.73-15 8.73-4.53 0-9.42-2.45-9.42-2.45s-5.59-7-4.89-9.07c.7-2.07 11.87-12.91 13.61-13.61 1.74-.7 5.24 1.05 5.24 1.05l5.58-4.89 9.12 8.38z",
    fill: "#FFB580"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.15 272.57l-5.24 5.58s2.45 4.54 1 6.28c-1.45 1.74-10.47 8.73-15 8.73-4.53 0-9.42-2.45-9.42-2.45s-5.59-7-4.89-9.07c.7-2.07 11.87-12.91 13.61-13.61 1.74-.7 5.24 1.05 5.24 1.05l5.58-4.89 9.12 8.38z",
    fill: "#EFB39C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.57 272.57l5.24 5.58s-2.45 4.54-1.05 6.28c1.4 1.74 10.47 8.73 15 8.73 4.53 0 9.42-2.45 9.42-2.45s5.59-7 4.89-9.07c-.7-2.07-11.87-12.91-13.61-13.61-1.74-.7-5.24 1.05-5.24 1.05l-5.58-4.89-9.07 8.38z",
    fill: "#FFC9B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.98 300.14l-.46-7.33",
    stroke: "#303030",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.55 267.68l6.98 7.33 12.21-11.17-6.98-8.02-12.21 11.86z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.54 167.97s-2.33 46.08-.93 49.33 25.59 38.63 25.59 38.63-6.05 12.1-16.28 13.49c0 0-32.58-27.45-34.44-31.18-1.86-3.73-7-21.87-7-27.45 0-5.58-5.12-50.26-2.33-60 2.79-9.74 15.82-19.55 23.27-22.34 7.45-2.79 10.7-3.72 10.7-3.72l1.42 43.24z",
    fill: "#3A3B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.29 118.31l-23.37 8.19 23.37 30.2-7.44 4.01 29.66 30.14-.41-17.48-21.81-55.06z",
    fill: "#131556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.18 267.68l-6.98 7.33-12.22-11.17 6.98-8.02 12.22 11.86z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.18 167.97s2.33 46.08.93 49.33-25.59 38.63-25.59 38.63 6.05 12.1 16.29 13.49c0 0 32.57-27.45 34.43-31.18 1.86-3.73 7-21.87 7-27.45 0-5.58 5.12-50.26 2.33-60-2.79-9.74-15.52-17.8-23-20.6a97.27 97.27 0 01-12.9-5.91l.51 43.69z",
    fill: "#3A3B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.79 118.34l22.46 10.91L349 156.7l7.45 4.01-29.67 30.14.42-17.48 20.59-55.03zM287.54 167.97c.25 8 .24 16 .19 24l-.06 11.94c0 3.95-.09 8 .22 11.79 0 .24 0 .46.07.65s0 .23 0 .28a.28.28 0 010 .1l.28.54c.09.18.2.37.33.59.49.83 1 1.67 1.54 2.51l3.2 5c2.11 3.37 4.3 6.7 6.41 10.09 4.25 6.74 8.46 13.53 12.42 20.48-5-6.23-9.79-12.64-14.42-19.14-2.35-3.23-4.59-6.54-6.85-9.83-1.13-1.65-2.22-3.33-3.31-5-.55-.84-1.08-1.7-1.62-2.58-.13-.2-.26-.44-.4-.71-.14-.27-.28-.5-.41-.78-.13-.28-.13-.41-.19-.62-.06-.21-.05-.3-.08-.46-.03-.16-.08-.57-.1-.83-.17-2.12-.16-4.1-.16-6.13 0-2.03 0-4 .1-6 .15-4 .3-8 .58-12 .56-7.99 1.23-15.95 2.26-23.89zM360.18 167.97c1 7.94 1.71 15.9 2.2 23.88.28 4 .43 8 .58 12 .07 2 .09 4 .1 6 .01 2 0 4-.16 6.13 0 .26 0 .53-.1.83-.1.3 0 .27-.08.46s-.12.42-.18.62-.28.52-.41.78c-.13.26-.28.51-.41.71-.533.88-1.073 1.74-1.62 2.58-1.09 1.69-2.18 3.37-3.3 5-2.27 3.29-4.51 6.6-6.86 9.83-4.63 6.5-9.39 12.91-14.42 19.14 4-6.95 8.17-13.74 12.43-20.48 2.1-3.39 4.29-6.72 6.4-10.09l3.21-5c.53-.84 1-1.68 1.53-2.51.13-.22.24-.41.33-.59l.28-.54a.28.28 0 010-.1v-.28c0-.09.05-.41.07-.65.31-3.78.21-7.84.22-11.79l-.06-11.94c.01-8.01.01-15.99.25-23.99z",
    fill: "#131556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.89 479.48c43.443 0 78.66-7.445 78.66-16.63 0-9.184-35.217-16.63-78.66-16.63s-78.66 7.446-78.66 16.63c0 9.185 35.217 16.63 78.66 16.63z",
    fill: "#E8E8E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "change-password-zona_svg__clip0_4141_8903"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h403.55v479.48H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/change-password-zona.8033f63d.svg";
export { SvgChangePasswordZona as ReactComponent };